
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[exchange]/[ticker]/insiders",
      function () {
        return require("private-next-pages/s/[exchange]/[ticker]/insiders/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[exchange]/[ticker]/insiders"])
      });
    }
  